import { useCallback, useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { connect, useDispatch } from "react-redux";
import { AvatarAction } from "../../redux/actions/AvatarAction";
import { AppConstant } from "../../redux/reducers";
import MButton from "../commons/MButton";
import { MClose } from "../commons/MIcon";
import MPageFooter from "../commons/MPageFooter";
import LoadingOverlay from "../overlays/LoadingOverlay";
import TermDoc from "../testComponents/TermDoc";

const SCROLL_GAP = 2;

const TermsCheckSidebar = ({ show, AgreeAvatar, CheckAvatarId, avatarItem }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [fillScreen, setFillScreen] = useState(false);
  const [isScrollDone, setIsScrollDone] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show) {
      setIsScrollDone(false);
    }
  }, [show]);

  const handlerScroll = useCallback((event) => {
    const eleScrollHeight = event.target.scrollHeight;
    const eleHeight = event.target.clientHeight;
    const eleScrollTop = event.target.scrollTop;
    if (eleScrollHeight <= (eleHeight + eleScrollTop + SCROLL_GAP)) {
      setIsScrollDone(true);
    }
  }, []);

  const checkTerms = useCallback(async () => {
    if (avatarItem?._id && avatarItem?.region) {
      setLoading(true);
      const isSuccess = await AgreeAvatar();
      if (isSuccess) {
        // dispatch({ type: AppConstant.SET_SHOW_TEAMS_CHECK, show: false });
        // dispatch({ type: AppConstant.SET_SHOW_PASSWORD, show: false });
        // await CheckAvatarId(avatarItem._id, avatarItem.region);
      }
      // setLoading(false);
    }
  }, [AgreeAvatar, CheckAvatarId, avatarItem._id, avatarItem.region, dispatch]);

  const handlerClose = useCallback(() => {
    dispatch({ type: AppConstant.SET_SHOW_TEAMS_CHECK, show: false });
  }, [dispatch])

  return <>
    <LoadingOverlay
      show={loading && show}
    />
    <Offcanvas
      show={show}
      onHide={handlerClose}
      placement="bottom"
      className="w-100 z-index-1047"
      backdropClassName="z-index-1046"
      style={{
        borderTopLeftRadius: 24,
        borderTopRightRadius: 24,
        height: show ? (fillScreen ? "calc(100vh - 72px)" : "65vh") : 0,
        transition: "all 0.2s",
      }}
      backdrop="static"
    >
      {show && <>
        <div
          className="position-absolute rounded-circle bg-white d-flex align-items-center justify-content-center cursor-pointer"
          style={{
            right: 16,
            top: -56,
            width: 40,
            height: 40,
          }}
          onClick={handlerClose}
        >
          <MClose className="text-gray-900" />
        </div>
      </>}
      <Offcanvas.Header
        className="align-items-center justify-content-center"
        onClick={() => setFillScreen(prev => !prev)}
      >
        <div
          className="bg-secondary-300"
          style={{
            width: "20%",
            maxWidth: 300,
            height: 6,
            borderRadius: 3,
          }}
        />
      </Offcanvas.Header>
      <Offcanvas.Body className="d-flex flex-column gap-2 p-0">
        <div className="flex-fill w-100 position-relative">
          <div
            className="position-absolute p-3"
            style={{
              inset: 0,
              overflowX: "hidden",
              overflowY: "auto",
            }}
            onScroll={handlerScroll}
          >
            <div className="text-black fw-bolder">
              {t("To securely load my Virtual Smile, agreement confirmation and consent are required.")}
            </div>
            <div className="fw-bolder text-gray-700">
              {t("Terms and Conditions")}
            </div>
            <div className="w-100 flex-fill position-relative" style={{ minHeight: "105%" }}>
              {/* TODO: 약관 으로 대체 */}
              <TermDoc />
            </div>
          </div>
        </div>
        {show && <>
          <MPageFooter position="absolute" css="bg-white px-3 pb-3 pt-1">
            <MButton
              css="w-100 text-white"
              color={"primary"}
              disabled={!isScrollDone}
              circle={true}
              height={56}
              onClick={() => isScrollDone && checkTerms()}
            >
              {!isScrollDone && <>
                {t("Read the entire content")}
              </>}
              {isScrollDone && <>
                {t("Agree to the terms and conditions.")}
              </>}
            </MButton>
          </MPageFooter>
        </>}
      </Offcanvas.Body>
    </Offcanvas>
  </>
};

const mapState = (state) => {
  const show = state.AppReducer.show.teamsCheck;
  const avatarItem = state.AvatarReducer.item;
  return { show, avatarItem };
};

const mapDispatch = dispatch => ({
  CheckAvatarId: (id, region) => dispatch(AvatarAction.CheckAvatarId(id, region)),
  AgreeAvatar: () => dispatch(AvatarAction.AgreeAvatar()),
});

export default connect(mapState, mapDispatch)(TermsCheckSidebar);
